import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/layout.js"
import SEO from "../components/seo-component.js"
// import GridIcons from "../components/content/gridicons"
import Helmet from "react-helmet"
import Safe from "react-safe"
import Subscribe from "../components/subscribe.js"
// import { Menu, MenuCTA } from "../components/content/menu"
import './home.css'

import { navigate } from '@reach/router';
import { Redirect } from '@reach/router'
const IndexPage = ({ siteTitle, data }) =>  {
  // require('./home.css');

  if ( process.env.GATSBY_ACTIVE_ENV=="demo" || process.env.REACT_APP_BUILD_ENV=="demo" || process.env.NODE_ENV=="development" ) {
    // return <Redirect to="/services/" nothrow />
    
        navigate(`/services/`); // DISABLE this by auth env key

  }
  return ((
  <StaticQuery
    query={graphql`
      query IndexPageQuery {
        site {
          siteMetadata {
            title
            url
            blogUrl
            appUrl
            getStartedUrl
            twitterUrl
            linkedInUrl
            feedbackUrl
            description
            homeDescription
            homeDescription2
            homeDescription3
            footerDescription
          }
        }
      }
    `}
    render={data => (
      <>
        {/* // Inside your component */}
        <Helmet
          bodyAttributes={{
            class: "home",
          }}
        />{" "}
        <Helmet>
          {/* <!-- IE10 viewport hack for Surface/desktop Windows 8 bug --> */}
          <link
            href="/theme/css/ie10-viewport-bug-workaround.css"
            rel="stylesheet"
          />
 
          {/* <!-- Custom styles for this template --> */}
          {/* <link href="/theme/css/cover.css" rel="stylesheet"/> */}
        </Helmet>    {/* <p>
                <Menu />{" "}
              </p> */}
        <Layout style={{backgroundColor: 'white'}} simple={true}>
          <SEO title={data.site.siteMetadata.description} />
          <div className="jumbotron page-header pt-6 pb-6 mb-6 mt-32  d-none d-sm-block" style={{backgroundColor: 'white'}}>
            {/* <div className="container">
              <h1 className="display-32">{" "}</h1>
              <h2 className="display-32">
              {" "}
              </h2>
              <p>{" "}
              </p>{" "}
          
            </div> */}
          </div>
          <div className="site-wrapper">
            <div className="site-wrapper-inner">
              <div className="cover-container">
                {/* 
    <div className="masthead clearfix">
      <div className="inner">
        <h3 className="masthead-brand">Cover</h3>
        <nav>
          <ul className="nav masthead-nav">
            <li className="active"><a href="#">Home</a></li>
            <li><a href="#">Features</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </nav>
      </div>
    </div> */}

                <div className="inner cover text-center">
                <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADACAYAAABS3GwHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAASAAAAEgARslrPgAAGlZJREFUeNrtnXl0nMWZr5+3vtZm2ewQsA22JIzXQJiB5ORkcubOCSErtmEmLOHmnpzJMJnAJHfuJJlzErLc5J65yWSDBDAwyQwhYMCGYMnGJGbCZd9MjFmsxbJbki2vspFtWUuru7967x+f2jHGsrbW933dXc85/OODVG+r31/Vr6reqgKHw+FwOBwOh8PhcDgcDofD4ShqJOoASpXaJU2IAAiokmxYEHVIJYmJOoBSpHZJE6p4wGLUftTzkbqlTVGHVZI4AYTM7CtaAZkihr8F7kDk536CyzzU1C5tiTq8ksNZoJCo+VgzptLi27JpxmT/lwhfAU4HUHgL+Cp4f0Cstq2aH3W4JYMTQAjMvuotPAxWOVWsfEOEm4Apx/xvTYp8JVNd9f/Ke/vVzQnCwVmgEDB+GZqVmcbKD0X4n7w7+QEWCHpreV//R0TF1Cx2c4IwcCPAJFK7uBljLD7mIoN+D/g04I3wY40o37TKWjB+++p5UX+MosaNAJNE3ZVNkDHGV/NXBl0GLGHk5AdYiPAzMSz2rfFqlriJ8WTiRoBJoGZxCyZhK9XnGhG+BZw/jl/TqSo/sGruRaW/Y80FUX+sosQJII/UXdEMnsVa73QRe+OQ3z99Ar+yW5VfWJv4mef5h61vaF8zN+qPWVQ4AeSJmis3Y8syeGlTK3AzcC3Hn+yOlX6Uu1T5gSTs/qw1bKt3K0T5ws0B8kDdkiZ8r8zzBs2HBe4BPk9+kh9gCsJXxHCL+t6cCveV5RU3AkyAGVdtocKmEZVK4GqEm4HJNOtPKvJNI7reV6G93m2YTRQngHFSt7SFck2TsmWnGU+/AtwInBlC0xvU8i1fEv8lJuN3rFoY9Z+ioHECGAc1S1pJeGJ8m/lz4F8ErgAqQgxhmyI/tmLvFyuH2t2u8bhxAhgDuYpNq4mpQvZzInwZiMqH9Cncp8qtnmGztdDmhDBmnABGSd3iRrACntSq6NcErgdOijgsC7ygyndFeNZa8dtXu3nBWHACGAU1SxsxvpZjzGUI3wQ+SLxW0Lap8kNrzUPG6MG2hnm4r3Z0uL/SMEy/YjNVno8I+KrnGuQG4O+Ac6KObRh6FB5E5ZZEub/Zzwiq4mzRCDgBHIe6pS14ksVXbwqqH1fhywJ/ASSijm0EfGCjqv4C39SbhB5OZyrYvrYu6rhiS5yG8VhQc2UjCSolo+Zi0FsQ/lPgvxH/5Ieg2O4SEVkmCb1TlUu2b6yldmlj1HHFFjcCALWXd0JlL2IsVjhVVK4X+CKwKOrYJkijKrchulKEA6qGNrd59g5KXgCzlzZj1IL1ytTwARH7TwIfA6ZGHVue6AHWqpqfqbBR1PrWK6Pj0TlRxxULSloAtVc0cyY97DPT6kCuF9EbgJlRxzUJKNAB3KHKSi+b7syWVbhSCkpQADVXNiNqEQHNmnPw7FWCfBb4AKM7sFLIpFV5DviNiqwx2AOoIH6CrY+V5nmDkhHA+R/fiq1IU+4PkDZVp4nwKYUviHAp+avcLBQOgj5nVe5WlWdIpHvxy+gowSXTkhDAzCubKceClTMR/hL0BkE+BFRHHVvEHET5vSq/8mG9JxzOemVsL6H5QVEKYPaSzXj4IMEHTImcXG71YyJcA1xO8Uxw80WXKmuAFVmv7NkyzQyiYC20ry7uUaHoBDB7yWYMPlgxip5hPC5TuE6C8oWJHE8sBXagPA0sV+XltiQHa+eAYEjWF+ftFEUjgPMWN+OJktWK8jIZnCvCZQQFa/NwVmesHAbWq7Ic4fkyrzqZ8fusLwm2rSquyXLBCqBmSRMiiiAYgUFfpnmiHxKRjwl6OUGZcsF+vpiQBt5Q5QmE3/uSeK1cMv2+DyKC+krXVuhtLtxDOQWVIDM/s4Py7GFELTMxdGKrrcosI3wS5TIR3gtMjzrOIqVdYRMq/wWyTvB3TplR3de/qx+r4FmfrWveG3WMY6YgBDD7ihbEWBKaJZson2qsP1tV/gzhU8CHJfD25VHHWSIMAvuAF1B+p8JrqmwTT3rwFbUw0G/Z82RhVJHEQgAzrnsbb6ALD0UUZGj1xohw9pST2N5z+FQxdqEIfy7wPuD9wFyKf+Mq7ligFfgj6Buq8rpa3hrot/tOOslYC6iCoqCCAiabILk2PvOIUARQs7gFNQqAsYKKBQL/DiCilKP0iWc8q5UClSrUiHIJwiUSJPtM4FwKoyqzFLHALmCnKu0Ib6K8LsgmFduj1qTeHiB95km+4hsURQiyAAXUYIdyBMAIhHFNfCjJpCoJVSpUVIYUVwFMBa0GmapI9SByRkL1POCioZ7+HIQqoDKMGB0TxhB0UjNF+ABwFcIgaD9Ik4huPKOaVrJmjwqHgF6gX1X7UNMvKikbSCF4NEoYBLKTHXQoAvA8/0INLos6SQKVVytyhsAZBP79NHK3KsTClDnyQPnQf9ME3oPwV0BuczIFsh84YIRuRA+A35MIRhEBDonPPcDrkx1kOCMA1Ar8D+Dk3L+5PC9pKhkaLY7+x6NyoluFpwhBACGdCFNDcFzP4RgNflgdZCgCEMTgOn3HWNCJ/4rREIoANLSP4ygSdGjVdNIJywIpTgSO0WMFDcUyh2OBVHyCGb7DMRqsBjkz6YRjgYQsTgCO0WNBM2E0FI4FUjK4VSDH6PERU0QCwAnAMSaygqbDaCgsAYSyre0oGrJAKoyGQtoH0BTBKOBwjIa0IgNhNBTOJFhJ4UYAx+jJKFpEAhDTT3C8zuEYDWmLKR4BiEofwTzA4RgNaU1LbxgNhSIAK34fbgRwjBKFgZ37aotnBEgb00tIs3pH4SNKb3Z9WfHUApmKCquqPWG05Sh8VLR7/gebQmkrFAHsSKUQkQO4gjjHyPgg3ZmqcBoL74kk1W5cPZBjZHyQ7uRT4dxJGo4A6hegIt24cgjHyPigb4fVWGgjgASXKTkBOEYiqypdYTUWmgBU2YPbDXaMjC/CnrAaC08AiBOAYzRkKMYRwAhdOAvkGAGFg+CHsgsMoa4C2T5gf2jtOY5g7dCp7MJgFyKhOYXwLJCQVbQzrPYcwaaLZ+CcMy0VFVoQIhBlJxqeVQ5vBECyguwMrz2HEbj0wixf+8IAn/hwhkQi/gpQYacf0nlgCPGmZatkjLDL3Y41+ShB8l+yKMsNn0kxa7pl1nSLqvL4M+VksoLE94vY6astvhEg7ftZwFmgSSaX/O+/MMM/XJvivOkW38KpJymfW5Jm8UfSlJfF1g4pyI7DvYOhVQyEJoBKr0xRduDKISaVXPLf8JlBzjvHYof+2lbh5GnKdZ9Ks+QjacrCKbYcK72i2jWlqiy8v1dYDbU1zAPR/UB3aJ+uhFCCl3UuWZTl768eZNZ0iz0mxzUngk8PiSARu5Fgj0LP7rUXhdZgiJNgEDhE8IqII48cz/bYYRJbFaZVK9d/Os1Vl6epKI+VCHYNPZ4RGqEKAEwPsDvcNouf4WzPcKjC1Grl6k+k+eshEcSEPapFLAAr9iBuBMgbo7E9w/7s0Ehw9SdiNRLswifUg1OhCiBr0/3qVoLyQs72fODCLP9w3Yltz7C/Q6F6inLtJ4ORoDLazTJf0R1IuOUyoQrAk4QSCCCUA8/FTGB7stxwdWpUtmdYFCrKlTNPs5SFt/hyPA4K0tmxJpyDMDlCFUBH/XshKIdwK0Hj5J22Z2LJL4Cv8Nwfy3jgsQoO90a6QXYADb9UJuRJMIDZDhwIv93CZyyrPSMhQNbCc6+WcdeKCrreNlHvDneretvCbjR0AagvnUBoR96KibGu9gzH0cn/y4crePtA5MkPsDelJ4V2DiBH6AKYdt6hXkXbcDdEjIkjtueasa32HA+r8Pwfy/jVIxXsjb7nh8CJtRrCeRXmaEIXQOuDCwF5C3dT3KjJJf8Xrxny/BNJfgvPb0hw95DtMdEnP8CgKm/1eOE749AFkOqeCsgm3F2hoyKX/DdcHVR1jnu1hz8l/7+vrGR/PGxPjkFRebOnPtwVIIhkEgwoLUBfJG2PNsQYGDQRuHhBlr+/JkXNjIlNeFXhhdcS/PLhSvbsj1XyA+wXdEcUDUciAFU9pEprFG2PGBvgeTB1ikaaJCJw6aIsN16XYvYEkh+CCe/zGxLc9VAle/fHxvYcTRMmnPcAjiWaEQAZBDZG0/aJObLMeF2K82f5kYwEf5rwppg1I3+2Z1937Hp+ABRez0o0lji0E2FH46FpK7zG0L5OFDEcDxH4swVZ/u5vBjlvumX6WZbb76+krdMLLXGOtj0T9fw52/OrIdsTw54fgvMhr3dXTInkCa1oLBCoqG4lRrdE5HrdI3U1Ft57gc8//vfwRoJcDF/Kg+2x8bc9OXYIbK/KRvOEXCQCSK5egCJ7IR7zgKNXWmYf1euqBiL40nUp5sz2J3XjYrgYxkMh2J6jaAW6uh65IJLGI5oDgAQXZUUugJFWWlThwrk+N12fou7cyRkJ8rXak4s3xqs9x6M1k/X2RdV4ZAKA8l7QJiK8LnG0lkMVFp3v8+XPpbhgdn5FUKK2J0cGpeXiuq7I9oQiFEAWVWkiuDU6dMZqOazCwvN9vvTZ/ImghG1Pjt2KNr7UPD2yACITQLJ+HhZtJKITYhfNC8qJx2I5VGHRHJ8br09Rd97ERFDitifHbqteU9cTdZEFEOEIAKmDFZ2KbiHEwjhjgl73xs+mmD1zfKeoJmqHStz25FBFW9Op8r1RBhGpACpPTVmQ9YRUGKcK1VXKRz+Upvbc8VuOidghZ3uOMCjIi4mybKRFJ5EKoKN+EaAvE9IRSRHoGxCeeL6c5HaDmcCnH48dcrbnHfRZMa9sXxvN8meOSAUwxGagLazGrIUNjQmWPVBJW+fELMNY7FC+bc+LGwvS9hzNZlHbHnUQkQtAVfoUng673TdaEtz1YCVbt08sgUZjh/Jte17cmODfVxSk7TmaZ1RN5BXBkQvA+qRRngNC3wvf2Bz0osnOybND+bY9L7+e4JcrK9m1r6CTP20tL+71yqKpfziKyAUggiK0Elih0HmjJcEdyytJbp9YQg1nh/Jpe17amODOByvZva9gbU+OJhHdMs1G/2KWF3UAB1vv4JQ5Nw2I4WLgfVHE0PW2oXO3oe5cn9NPHf/lUAqcdboya7qlY5dH7UzLDXno+Y/YnpUFO+E9lrUiZmVn/Tw3AgC8r66zF9hAhMck39ic4K4VQxPjCdqhhXN8/vnzA/zj5ybe86vCS8Vhe3IMoLxGTE4ERj4CALTYn3HK1D4VkY8Cp0UVx979hvYdXjASnDKx5enTT1amVU/sqkFrg+S/68FY1/OPlXZEfp6snx+LS5JjMQKw/izEmE1Ac9ShNG7xWPZgJZvbJ9bbWiU/tmdFZVyuLskXzWhZY9RB5IiHAAIGFJ4iBtelbGoNVoe2dEzMDo2XIlrtOZa0wjPE6EaQ2AigbdV8BP5ATK5NbNyS4PblVbROcCQYK0W22nMshwT+kGw4P+o4jhAbAQCoSgfKhqjjyNGczI8dGi0523N38dkeAFR1o6qGfv/niYiVAESlT0UeJ0bXJjZuCcomNrdPrh0qYttz5CMislZVe6MO5GhiJQDACvoiIdYGjYbmZILb7q+ipW1yErPIbU+OTlRfJGavhMZKAMnV8wDdCjwbdSzH0truseyBSpqT+RVBsdueHKo8baG1ffWiqEN5B7ESwBCHCVYKQn0rajQ0JxMse6CK5qSXt176lTeL2vbk6EV4TmL4ncZOAMn6hSjyLLA16liOx+Z2j9vvr6QpObHLsnKe/84Hitr25GhT9Nn2hoVRx/EuYicAgLbueR2qvADhPpg2WrZsC+xQ49bxiSCX/Hc/VDS1PSfCqvKKlyqPZYcWSwGIsYrwW2I4ZOZoaf+TCMbae7/yRrDDu6Or6JMfAvuzConX5DdHLAWgT3tIcHnuK1HHMhxCMDG+7b5KNo1yJMj1/MseqGRnV9HbnqEPzVuovrz1d3OijuS4xFIAAFlLr4VHiPDirJEQgeR2j2XLK9m05cQiKDHbc/THflh9L7YjeWwFQLBe/AIQm8Kp4yECrR0edz5wYhGUmO3JkUR5JuzHr8dCbAWwbfUCJE0SWEfMNk+OJSeC2+6r5K3Wd4qgJG3PkQ/Pk2LNlvY186KOZFhiKwAAKskATwKxqB0/ESLQ1hlMjN/cHIigRG1Pjm5Fn7Rl2VgcfBmO2H8ls5e0Vntk70dYGnUso0EVzp/l86VrU/QNCHc/FNiekur5AYWnsN7VbavnxuYNiOMRyQsxY6FaD/elpOo3wEeAaVHHMxK5ifFP76liMC28fVBKLvmBlCIPTMnsjHXyQ9wtENBU/j6s5SlFY7skejx27zN0H5JSsz0AKDQhuravoibqUEYk9gLQRzwo83tA7iUGp8UcI2IF7helq6PeCSA/WLFWzTMKz0cdimNEGhVdR0zLWI6lIATQXr+Ijv5zOkWpB/qjjscxLL4qj2XVJNsiePV9PBSEAIJIM6jKaoW3og7FMSxJYJXE6ND7SBSOANadQdve92xD+Q2Qijocx7vwFW0whg3bGuZHHcuoKRwBALPO6sKKPAoay1fmS5ztqNyrGu9d+2MpKAFsWzOPMj/bpWp+hVsRihOq8KAvtCYLxPvnKCgBAFhjrMA6NPw3BRzD0gK6YkbVocgvux0rBSeAZMNCfMxORR8CDkYdj4M0sFLRlo7eyK51HTcFJwCAjoa5+Ebqhx7WcESIwiZFlgPpXWvmRh3OmClIAQCc4nNAkduJ6KFtBxCsxv1HR+WsLe318bruZLQUrADerFAEfRZYGXUsJczL1srD5w7uiDqOcVOwAtCHFwKkVPUeoDXqeEqQXoVlxsu+vW1VtE+dToSCFQBAsmEB6YS+jnIfBbT7WCSsRnlSVQpq3f9YCloAABUZ8S2yXOGPUcdSMiidqP6neF53oXr/HAUvgOTqhcx8T1s7cCtwKOp4SoCMCr/xxT6bfLTwVn2OpeAFAPDchk+A2sc1sEIFPSTHHVXWW+stE6TgNr2OR1EIgA0GxPSj5g6IzwMbRch+4Kea8XcXuvXJURwCANrqF6CSbVVlGTF5ZqnIsMAKYJ1IfB4wmShFIwAA1Fg/qw8DDTgrlG9eV9U7Ufo7Hi+sgrcTUVQCaF+9gESZ9KHcAjRFHU8RcdjCrcaTRvlB4dT6j4aiEgBAsn4BeP4mVf0hrlguH6iqLveRR7c+uoDkwuK65qLoBACANdZXVqnyH7hzAxPlZeDWTHlVrG94Gy9FKYBk/UI8oR/MMoILdh3jY4/Cj0Rkc2UqVo875o3iGs+O4cIr1tNrpl0movcBZ0cdT4GRAX7q+/zvjjULirbMpChHgBxvVl6KqjwD3AIMRB1PgfG0xfxcpLhrrIpaADwsqGpGVe9RZQUFcllTDGgEvuuR3dO+uniWPI9HcQsA6FgzH2CfYv5VcSfIRsE+Vf7NYtZvLZLd3hNR9AIAaGtYSEYObFXVb6g7O3AiMsBdqWzFCkFLYrQsCQEAVOiZ4HuvovwfoCvqeOKIoo/4ordWJQbSbfXFteE1HCUjgGTD+QRvVdnfDtULudvljkLhRVX+1Ut43cmG4rc+OUpGAADBW1UyoKq/UPReYvwCZci0ovrdrO83pfuLetHnXZSUACCYD2DkgLHyPZRHoHgqG8fJbot+p23Kgj8kPE87114UdTyhUnICAGivXwBeerfCtxTWUroiOAjyvZQnj5CF9oaFUccTOiUpAADtO4NqL53E6jcozeXRPpR/U5Fflyk+Dxd1UcCwlKwAkk/MpNevAM9sUvRmYFPUMYVIGuVO1NwpVge3P1rcm10nojRlfwyzlm4WD//jEpRMFP5J7xOTVeVexXzDKPuSq+P7iHUYlOwIcDQevlr4vSr/DDRHHc8kkgbuQfXb4JIfnACA4DyxAW1rmP+4Wr4KtEQd0ySQAe5T+L4Y2Y26E6PgLNAxKFNndclZF739STH8BCiWLtInSP6bgV2F8oBdGLgR4B0Ip887oOl+87ha/onimBhngPtV+ba45H8XTgDHsG3dPMqqrJ7zwR3rhuYEhXzPUFrh16p8R4QdzvS8G2eBhkVZ+PWnGGg9+1KE7wtcTmF1GH0Kd6jyE4F9bQ2u5z8ehfSFhozQv2kG5cqrFrlJ4X4K5wbqfar6HVX5vqAu+U+AE8AJaP/dXAYNGLQNq18DbgN6oo5rBLap8vWMereD9vleedTxxBpngUZJ7eJGVLxpgn5RRL9KPA/Zb1LLzX0Dpz5WXnXIdrp1/hFxAhgDtUua8a0kPOMvEZHvABdGHdMQWeAJq/r9voPV66umZXTbY3OijqkgcAIYIzWLm2k/rYKag6mLjXIzwqeBighD6gHu9UV+5KnusL7QvqY0TnPlAyeAcXDaNa2cMphFrZxtjN4E3AScGkEoHQo/wXr3Wc/2dKxyiT9WnADGjVK7pAVFKwSWivBtIKyCelXVl0Bu9g3PJazxkw3O748Htwo0boS2hnkYYbDn0PwVIH8L/JbJP2bZC/xa4AvG6NNGcck/AdwIkAdmfLyfysptgJ6t8HkJLNHMfLej0Ab8WC0rjWh3sgRPcOUbJ4A8Ure0iazVhIf5C4x+XeAyIB8L8QPA76zyo4zKq+Wi1m1u5Qcv6gCKiQNz/4bTZKr1jHb4Vp4y6AAidcDJE/i12xT9EZb/azw2G9B2l/x5w40Ak8TsxU14KuXq2b8E+ReBDzO25dJBhaeBHw9a80wFfrZttbM8+cYJYBKpW9yEZxJkfP8sMfazInI9cBFQdoIfU6BR0XtUZHmZZvYOahnbXK8/KTgBTDI1SzchYnh11Xzev7hljop+RoTrCJZMj/377ya4xfrXkHhTJauK0F4i1xRGgRNASCy4oIfBeTvJ2DNNwutahHAtcL3ADIJrGteB3OFn9CUvwQB4JBuK/Xx+9DgBhEzN4i0kZJCsJMrBLhK4FtVNqKw2fvagbxK0r3F2JyycACLg7KXtTCGFqFKGISs2eNTYS9D22wuiDs/hcDgcDofD4XA4HA6Hw+FwOBzFw/8H24jSh2leNhgAAAAPdEVYdEF1dGhvcgBMb2dhc3RlcvRatAoAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMDEtMjZUMTM6MDg6MDQrMDA6MDBDAI0rAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTAxLTI2VDEzOjA4OjA0KzAwOjAwMl01lwAAAABJRU5ErkJggg=="
                      alt="DataPolicyTrust.com"
                      className="text-center pb-2"
                      height="100"
                    />

                  {/* <div className="row"> */}
                  {/* <div className="col-md-12 col-md-offset-1b col-sm-12 text-center"> */}
                  <h1 className="cover-heading text-primary">
                    {data.site.siteMetadata.description}
                  </h1>
                  <br />
                  {/* <p>
                    
                  </p> */}
                  {/* </div> */}
                  {/* </div> */}
                  {/* <h1 className="cover-heading">Cover your page.</h1> */}

                  <div className="container">
                    <div
                      id="carouselContent"
                      className="carousel slide"
                      data-ride="carousel"
                    >
                      <div className="carousel-inner" role="listbox">
                          <div
                          className="carousel-item active text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            
                          Instantly review data privacy & data protection practices of tech companies.
                          </p>
                        </div>

                        <div
                          className="carousel-item  text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            
                          Instantly review data privacy & data protection practices of apps.
                          </p>
                        </div>
                        <div
                          className="carousel-item  text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            
                          Instantly review data privacy & data protection practices of websites & social media.
                          </p>
                        </div>

                        <div
                          className="carousel-item  text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            
                          Instantly review data privacy & data protection practices of IoT products & devices.
                          </p>
                        </div>
                        <div
                          className="carousel-item  text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            
                          Instantly review data privacy & data protection practices of software & services.
                          </p>
                        </div>
                          <div
                          className="carousel-item  text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            
                          Streamlining procurement of technology solutions for business customers.
                          </p>
                        </div>
                          <div
                          className="carousel-item text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {/* {data.site.siteMetadata.footerDescription}  */}
                            Solving Data Protection Transparency for customers and providers.
                          </p>
                        </div>
                        <div
                          className="carousel-item text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {data.site.siteMetadata.homeDescription}
                          </p>
                        </div>
                      
                        <div
                          className="carousel-item text-center p-4b"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {data.site.siteMetadata.homeDescription3} 
                          </p>
                        </div>
                        {/* <div
                          className="carousel-item text-center p-4"
                          data-interval="10000"
                        >
                          <p className="lead"> 
                            {data.site.siteMetadata.description2} 
                          </p>
                        </div> */}
                      </div>
                      <a
                        className="carousel-control-prev"
                        href="#carouselContent"
                        role="button"
                        data-slide="prev"
                      >
                        {/* <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        /> */}
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="carousel-control-next"
                        href="#carouselContent"
                        role="button"
                        data-slide="next"
                      >
                        {/* <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        /> */}
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
                  </div>

                  <p>
                    <br />
                    {/* <Menu /> */}
                    {/* <MenuCTA /> */}
                    </p> <p>
                    <br /> 
                    <span className="text-muted">Request Early Access</span>
                    
                    <br />
                  </p>
                  <p>
                    {/* <p className="lead"> */}
                    {/* <a href="/" className="btn btn-lg btn-default">
                      Learn more
                    </a> */}
                    <Subscribe />
                    {/* </p>   */}
                    <br/>
                  </p>
             
              
                </div>
                </div>
                <div>
                <div className="page-header__ text-center"><div className="cover-container2">
                  {/* <hr/><br/> */}
                {/* <h2>Simplifying data privacy trust &amp; transparency.</h2> */}
    {/* <p className="lead text-primary pb-2 pt-2">
        Free data protection intelligence on apps, sites &amp; providers for people with premium benefits for businesses.
      </p>  */}
                  
                  {/* <div className="col-xs-auto">
                    <img alt="DataPolicyTrust.com" src="/images/b2bscreenshot1.png" className="center-block  img-responsive mx-auto" />
                    
                    </div>      */}
	    {/*
                    <div className="container mr-auto ml-auto text-center ">
      <img alt="DataPolicyTrust.com"   src="/images/b2bscreenshot1.png" className="pt-4 center-block img-responsive border border-light" />
    </div> */ } 
                    
                    </div></div>
                {/* <div className="container mr-auto ml-auto text-center ">

<hr/>           <br/>
      <img alt="DataPolicyTrust.com" width="90%" src="/images/b2bscreenshot1.png" className="center-block img-responsive border border-light" />
    </div>  */}
    <div className="cover-container fixed-bottom pb-3">

                <div className="mastfoot  text-center text-muted">
                  <div className="inner">
                    <div className={"copyright"}>
                      <p>
                        <small>
                          Copyright {new Date().getFullYear()}.{" "}
                          <a
                            href={data.site.siteMetadata.url}
                            title={data.site.siteMetadata.title}
                          >
                            {data.site.siteMetadata.title}
                          </a>
                          .{/* All rights reserved.   */}{" "}
                          <Link to="/privacy" title={"Privacy Policy"}>
                            Privacy Policy
                          </Link>
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </Layout>
      </>
    )}
  />
))}

IndexPage.propTypes = {
  siteTitle: PropTypes.string,
}

IndexPage.defaultProps = {
  siteTitle: ``,
}

export default IndexPage
